/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M149.431 43.508c-50.12 0-101.924 42.637-101.924 113.96 0 88.35 135.483 210.636 208.488 264.005 72.977-53.369 208.46-175.655 208.46-264.004 0-71.324-51.804-113.961-101.895-113.961-16.91 0-59.315 5.569-87.48 57.14-7.657 13.951-30.542 13.98-38.17 0-28.193-51.571-70.57-57.14-87.479-57.14m82.52 414.28C208.571 440.79 4 288.31 4 157.468 4 58.91 77.934 0 149.431 0c40.868 0 78.952 18.882 106.564 51.745C283.58 18.882 321.663 0 362.56 0c71.497 0 145.402 58.91 145.402 157.469 0 130.842-204.543 283.322-227.863 300.29-7.107 5.134-15.431 7.831-24.104 7.831-8.672 0-16.997-2.697-24.045-7.802z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconHeartOutline = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconHeartOutline.defaultProps = {
  theme,
};
IconHeartOutline.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconHeartOutline.displayName = 'IconHeartOutline';
export { IconHeartOutline };
